import { onMounted, onBeforeUnmount } from 'vue'

interface HistoryState {
  popup?: boolean
}

export const popupBackHandler = () => {
  const isPopupOpen = useState<boolean>('v2-login-popup', () => false)

  const openPopup = (): void => {
    isPopupOpen.value = true
    history.pushState({ popup: true } as HistoryState, '')
  }

  const closePopup = (): void => {
    history.back()
  }

  const handlePopState = (event: PopStateEvent): void => {
    const state = event.state as HistoryState
    if (!state?.popup && isPopupOpen.value) {
      isPopupOpen.value = false
    }
  }

  onMounted(() => {
    window.addEventListener('popstate', handlePopState)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('popstate', handlePopState)
  })

  return {
    isPopupOpen,
    openPopup,
    closePopup,
  }
}